/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "./config";

async function reqDelegado(params) {
  const API_URI_ALL_DELEGATE = Config.rutasInterconexion.delegado;
  try {
    const response = await axios.post(API_URI_ALL_DELEGATE, params);
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export default {
  reqDelegado,
};
